var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#102262",
    d: "M12 7.75a.75.75 0 0 0 0-1.5v1.5Zm-8.493 4.776a.75.75 0 1 0 1.486.198l-1.486-.198Zm.986 3.948a.75.75 0 1 0-1.486-.198l1.486.198Zm15.903.997-.743.1.743-.1Zm-1.677-6.903.934 7.002 1.487-.198-.934-7.002-1.487.198ZM16.431 21.25H7.57v1.5h8.862v-1.5ZM8.502 7.75H12v-1.5H8.502v1.5Zm-3.259 3.1.038-.28-1.487-.198-.037.279 1.486.198Zm-.25 1.874.25-1.875-1.486-.198-.25 1.875 1.486.198Zm-.646 4.846.146-1.096-1.486-.198-.147 1.096 1.487.198Zm3.222 3.68a3.25 3.25 0 0 1-3.222-3.68l-1.487-.198A4.75 4.75 0 0 0 7.57 22.75v-1.5Zm12.084-3.68a3.25 3.25 0 0 1-3.222 3.68v1.5a4.75 4.75 0 0 0 4.709-5.378l-1.487.198Zm.553-7.2A4.748 4.748 0 0 0 15.5 6.25v1.5a3.248 3.248 0 0 1 3.22 2.818l1.486-.198ZM8.502 6.25a4.75 4.75 0 0 0-4.708 4.122l1.487.198a3.25 3.25 0 0 1 3.221-2.82v-1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.5 15 2 2 4-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M16 9V6a4 4 0 0 0-4-4v0a4 4 0 0 0-4 4v3"
  })));
};
export default SvgBag;